import { Grid } from "@mui/material";
import { FilterContainer } from "components";
import { Filters, Results } from "./components";

let ShipmentTypes = () => {

    return (
        <Grid container spacing={1}>
            <Grid item xs={12}>
                <FilterContainer>
                    <Filters />
                </FilterContainer>
            </Grid>
            <Grid item xs={12}>
                <Results />
            </Grid>
        </Grid >
    );
}

export default ShipmentTypes;